<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-panel header="{{ 'GARANTIASIDONEAS.LBL_TIPOPRODUCTOR' | translate}}">

        <div class="grid">
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>{{ 'GARANTIASIDONEAS.LBL_TIPOPRODUCTORCODIGO' | translate }}:</label>
              <label class="falso-combo-texto">{{tiposProductores.codigo}}</label>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>{{ 'GARANTIASIDONEAS.LBL_TIPOPRODUCTORNOMBRE' | translate }}:</label>
              <label class="falso-combo-texto">{{tiposProductores.nombre}}</label>
            </div>
          </div>
        </div>

        <div class="grid">
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>{{ 'GARANTIASIDONEAS.LBL_MONTOMINIMO' | translate }}:</label>
              <label class="falso-combo-texto">{{tiposProductores.rangoMinimo}}</label>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>{{ 'GARANTIASIDONEAS.LBL_MONTOMAXIMO' | translate }}:</label>
              <label class="falso-combo-texto">{{tiposProductores.rangoMaximo}}</label>
            </div>
          </div>
        </div>

        <div class="grid form-group">
          <div class="col-12 md:col-4 lg:col-4 ">
            <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                        id="indicadorHabilitado"
                        name="nomIndicadorHabilitado"
                        [ngModel]="tiposProductores.indicadorHabilitado"
                        [disabled]="true"></p-checkbox>
          </div>
        </div>

        <div class="grid form-footer-buttons">
          <div class="form-group col-12">
            <div>
              <button icon="fa fa-arrow-left" label="{{'BTN_REGRESAR' | translate }}"
                      type="button" (click)="regresar(false)"
                      pButton></button>
            </div>
          </div>
        </div>
      </p-panel>
    </div>
  </div>
</div>



